import { API_BASE_URL } from "@/lib/apiBase";

const API = `${API_BASE_URL}/api`;
const TOKEN_KEY = "yc-admin-token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private mode */
  }
};

const readDetail = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (typeof data.detail === "string") return data.detail;
  if (Array.isArray(data.detail)) return data.detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return null;
};

export async function adminLogin(email, password) {
  const res = await fetch(`${API}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const detail = await readDetail(res);
    throw new Error(detail || "Login failed");
  }
  const data = await res.json();
  try {
    localStorage.setItem(TOKEN_KEY, data.token);
  } catch {
    /* private mode */
  }
  return data;
}

export async function adminFetch(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    clearToken();
    window.location.href = "/admin/login";
    throw new Error("Unauthorized");
  }
  if (!res.ok) {
    const detail = await readDetail(res);
    throw new Error(detail || "Request failed");
  }
  return res.json();
}

async function uploadFile(file, path, fallback) {
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken() || ""}` },
    body: form,
  });
  if (res.status === 401) {
    clearToken();
    window.location.href = "/admin/login";
    throw new Error("Unauthorized");
  }
  if (!res.ok) throw new Error((await readDetail(res)) || fallback);
  return res.json();
}

export const adminUpload = (file) => uploadFile(file, "/admin/media", "Image upload failed");
export const adminUploadVideo = (file) => uploadFile(file, "/admin/video", "Video upload failed");
